import { render } from "./ContactsItem.vue?vue&type=template&id=cb77cb88&scoped=true"
import script from "./ContactsItem.vue?vue&type=script&lang=js"
export * from "./ContactsItem.vue?vue&type=script&lang=js"

import "./ContactsItem.vue?vue&type=style&index=0&id=cb77cb88&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-cb77cb88"

export default script